<template>
  <div
    class="modal fade"
    :id="dialogId"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            ×
          </button>
          <h4 class="modal-title">
            <b>{{ notificationTitle }}</b>
          </h4>
        </div>
        <div class="modal-body" v-if="!htmlText">
          <slot></slot>
        </div>
        <div class="modal-body" v-else v-html="htmlText">{{ htmlText }}</div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-raised"
            :class="[this.colorRed ? 'btn-danger' : 'dialog-btn-primary']"
            data-dismiss="modal"
          >
            {{ closeButtonText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotificationDialog",
  props: {
    dialogId: {
      type: String,
      default: "notificationDialog",
    },
    notificationTitle: {
      type: String,
      default: "",
    },
    closeButtonText: {
      type: String,
      default: "Close",
    },
    showDialog: {
      type: Boolean,
      default: false,
    },
    colorRed: {
      type: Boolean,
      default: false,
    },
    htmlText: {
      type: String,
      default: "",
    },
  },
  methods: {
    openNotificationDialog() {
      this.$nextTick(() => {
        $("#" + this.dialogId).modal("show");
      });
    },
    closeNotificationDialog() {
      $("#" + this.dialogId).modal("hide");
    },
  },
  mounted() {
    $("#" + this.dialogId).on("hide.bs.modal", (e) =>
      this.$emit("closeDialog")
    );
    $("#" + this.dialogId).on("hidden.bs.modal", (e) => {
      this.$emit("dialogClosed");
    });
  },
  watch: {
    showDialog() {
      if (this.showDialog) {
        this.openNotificationDialog();
      } else {
        this.closeNotificationDialog();
      }
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// NotificationDialog.vue?199635fc